import styled from '@emotion/styled';
import { css, type Theme } from '@emotion/react';
import ArrowLast from '@engineering/icons/arrow-last';
import ArrowNext from '@engineering/icons/arrow-next';

const getArrowStyles = (theme: Theme) => css`
  width: 1.35rem;
  height: 1.35rem;
  fill: ${theme.colors.brand.green120};
`;

const StyledArrowNext = styled(ArrowNext)`
  ${({ theme }) => getArrowStyles(theme)};
`;

const StyledArrowLast = styled(ArrowLast)`
  ${({ theme }) => getArrowStyles(theme)};
`;

const BreadcrumbsContentContainer = styled.div`
  display: flex;
  align-items: center;
  isolation: isolate;
  width: 100%;
  background: ${({ theme }) => theme.colors.neutral.white100};
`;

const ArrowButton = styled.button<{ visible: boolean; side: 'left' | 'right' }>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 20;
  overflow: hidden;
  width: 42px;
  cursor: pointer;
  padding: 0;
  border: none;
  background: transparent;
  ${({ side }) => (side === 'right' ? 'right: 0;' : 'left: 0;')}
`;

const InnerBox = styled.div<{ side: 'left' | 'right' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: ${({ theme }) => theme.colors.neutral.white100};
  border: ${({ theme }) => `${theme.colors.neutral.grey40} 1px solid`};

  ${({ side }) =>
    side === 'right'
      ? `
      box-shadow: -4px 0 8px -2px rgba(0, 0, 0, 0.25);
      margin-left: 6px;
      `
      : `
      margin-right: 6px;
      box-shadow: 4px 0 8px -2px rgba(0, 0, 0, 0.25);
      `}
`;

const ScrollContainer = styled.div`
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  display: flex;
  flex: 1;
  padding: 0.5rem 0;
`;

const BreadcrumbList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 1rem;
`;

const BreadcrumbItem = styled.li`
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.neutral.grey120};

  &:not(:last-child)::after {
    content: '\0000a0|\0000a0';
    margin: 0 1.2rem;
    vertical-align: top;
    line-height: 1.2rem;
  }
`;

const BreadcrumbText = styled.span<{ isLast: boolean }>`
  font-weight: ${({ isLast }) => (isLast ? 'bold' : '')};
`;

export {
  BreadcrumbsContentContainer,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbText,
  ScrollContainer,
  ArrowButton,
  InnerBox,
  StyledArrowNext,
  StyledArrowLast,
};
